<template>
  <div id="footer" class="container-fluid">
      <div style="margin-right:40px;">© 2021-2026 对外演出节目库</div>
      <div><a href="https://beian.miit.gov.cn/" target="_target" style="color: #777777;font-weight:normal;">京ICP备18060883号-2</a></div>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data () {
    return {};
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  height: 36px;
  position: fixed;
  bottom:0;
  left: 0;
  background: #FFFFFF;
  color:#777777;
  display: flex;
  justify-content: center;
  text-align: center;
  align-items: center;
}

#footer div{
  font-size:16px;
  color:#777777;
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue